module.exports = __webpack_public_path__ + "img/123.edec0d85.png";